/**
 * Correspondence slider
 *
 * 状態クラス（is-active / is-next / is-far-next / is-prev）を切り替える方式。
 * 切り替わりアニメーションは SCSS 側の transition で表現するので、
 * "独特なアニメーション" の調整は SCSS のクラス定義を編集するだけでOK。
 */
export const initCorrespondenceSlider = () => {
  document.querySelectorAll('[data-slider]').forEach((slider) => {
    const track = slider.querySelector('[data-slider-track]');
    if (!track) return;

    const slides = Array.from(track.querySelectorAll('[data-slide]'));
    if (!slides.length) return;

    const prevBtn = slider.querySelector('[data-slider-prev]');
    const nextBtn = slider.querySelector('[data-slider-next]');
    const counterEl = document.querySelector('[data-counter-current]');

    const total = slides.length;
    let current = 0;
    let isAnimating = false;

    // 状態クラス: 現在のindexからの相対位置でクラスを決める
    const stateClassFor = (offset) => {
      // offset = (index - current + total) % total
      if (offset === 0) return 'is-active';
      if (offset === 1) return 'is-next';
      if (offset === 2) return 'is-far-next';
      // 残り（prev側）
      return 'is-prev';
    };

    // 全カードを一番背の高いカードの高さに揃える
    const lockTrackHeight = () => {
      // 一旦リセットして各カードの自然高を測る
      track.style.height = '';
      slides.forEach((slide) => { slide.style.height = ''; });

      let max = 0;
      slides.forEach((slide) => {
        const h = slide.offsetHeight;
        if (h > max) max = h;
      });
      if (max <= 0) return;

      // 全カードを max 高さに統一
      slides.forEach((slide) => { slide.style.height = `${max}px`; });
      // track も同じ高さに（スクロール時に下に余白が出ないよう）
      track.style.height = `${max}px`;
    };

    const render = () => {
      slides.forEach((slide, i) => {
        slide.classList.remove('is-active', 'is-next', 'is-far-next', 'is-prev');
        const offset = (i - current + total) % total;
        slide.classList.add(stateClassFor(offset));
        slide.setAttribute('aria-hidden', offset === 0 ? 'false' : 'true');
      });

      if (counterEl) {
        counterEl.textContent = String(current + 1).padStart(2, '0');
      }
    };

    const go = (delta) => {
      if (isAnimating) return;
      isAnimating = true;
      current = (current + delta + total) % total;
      render();
      // SCSS の transition duration と揃える（600ms 余裕見て700ms）
      window.setTimeout(() => { isAnimating = false; }, 700);
    };

    prevBtn?.addEventListener('click', () => go(-1));
    nextBtn?.addEventListener('click', () => go(1));

    // キーボード対応（フォーカス時）
    slider.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') go(-1);
      if (e.key === 'ArrowRight') go(1);
    });

    // 初期描画
    render();
    // 初回の高さ固定（フォントや画像の読み込みを少し待つ）
    requestAnimationFrame(lockTrackHeight);

    // ウィンドウリサイズで再計算
    let resizeRaf = 0;
    window.addEventListener('resize', () => {
      cancelAnimationFrame(resizeRaf);
      resizeRaf = requestAnimationFrame(lockTrackHeight);
    });

    // 画像読み込み完了後にも再計算
    track.querySelectorAll('img').forEach((img) => {
      if (img.complete) return;
      img.addEventListener('load', lockTrackHeight, { once: true });
    });
  });
};
